import React, { useEffect, useState, useCallback } from "react";
import {
  Divider,
  Tooltip,
  Typography,
  IconButton,
  Badge,
  Grid,
} from "@material-ui/core";
import Modal from "../../cm_shared/cm_global_modal";
import axios from "axios";
import DataTable from "react-data-table-component";
import { NoteAdd as NoteAddIcon } from "@material-ui/icons";
import ScenarioGroupingFlow from "../ScenarioGroupingFlow";
import options from "./options";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import { Link } from "react-router-dom";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import PGScenarioLogicalNameListing from '../OpenLoopListing/PGScenariosLogicalBased/index'
import PRDataSubtableListing from "../PRDataSubtableListing";
import styled from "styled-components";

const parseJSONString = (str) => {
  try {
    return JSON.parse(str.replace(/'/g, '"'));
  } catch (error) {
    return str;
  }
};

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 450px)
  }
`;

function PRDataListing(props) {
  console.log('rendered on page load---------------');
  const [loading, setLoading] = useState(false);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const initialColumns = [
    {
      name: "Date",
      selector: "date",
      sortable: false,
      reorder: false,
    },
    {
      name: "Time",
      selector: "time",
      sortable: false,
      reorder: false,
    },
    {
      name: "Country",
      selector: "country",
      sortable: false,
      reorder: false,
    },
    {
      name: "Weather",
      selector: "weather",
      sortable: false,
      reorder: false,
    },
    {
      name: "Domain",
      selector: "domain",
      sortable: false,
      reorder: false,
    },
    {
      name: "Infrastructure",
      selector: "infrastructure",
      sortable: false,
      reorder: false,
    },
    {
      name: "Light Condition",
      selector: "lightcondition",
      sortable: false,
      reorder: false,
    }
  ];
  
  const fetchScenarioCollectionNew = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `http://localhost:3010/pg_data_listing`,
      );
      console.log('pgData', response);
      setScenarioCollectionNew(response.data);
    } catch(error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScenarioCollectionNew()
  }, [])

  return (
    <div
      style={{
        padding: "1rem",
        position: "relative",
        background: "white",
        margin: "30px",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Open Loop </Link>{">"} PR {">"} Data Listing
        </Typography>
        <div>
        </div>
      </div>
      <Divider />

      <div style={{ overflowX: "auto" }}>
        {loading === false && initialColumns.length > 0 ? (
          <StyledDataTable
            columns={initialColumns}
            data={scenarioCollectionNew}
            customStyles={customStyles}
            progressPending={loading}
            loading={loading}
            expandableRowsComponent={<PRDataSubtableListing />}
            expandableRows
          ></StyledDataTable>
        ) : null}
      </div>
    </div>
  );
}

export default PRDataListing;
